import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
// import { useAtom, useAtomValue } from 'jotai';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// import { fetch_all, fetch_one } from '../../lib/server_helper';
import { fetch_one, fetch_all } from "../../lib/v31lib";
// import { currentPracticeAtom } from '../../lib/practice';
// import { loginAtom } from '../../lib/auth';

import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import {
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  Grid,
  MenuItem
} from '@mui/material';

import {
  Button,
  DatePicker,
  Select,
  TextInput,
  Typography
} from '../../components/v2/styled';
import { Alert } from '../../components/v2/dialogs/Alert';

import { CoachSkill } from '../../models/CoachSkill';
import { Country } from '../../models/Country';
import { User } from '../../models/User';

// const { DateTime } = require("luxon");

type Props = {
  onlyFull?: boolean;
};

export const SharedRegisterCoach: FunctionComponent<Props> = ({onlyFull}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const matchessm = useMediaQuery(theme.breakpoints.up('sm'));

  // let [searchParams, setSearchParams] = useSearchParams();
  // const [login, setLogin] = useAtom(loginAtom);
  // const currentPractice = useAtomValue(currentPracticeAtom);
  // const [forgotPasswordOpen, setForgotPasswordOpen] = useState<boolean>(false);
  // const [editPasswordOpen, setEditPasswordOpen] = useState<boolean>(false);

  const [practiceName, setPracticeName] = useState<string>('');
  const [practiceEmail, setPracticeEmail] = useState<string>('');
  const [practiceStreet, setPracticeStreet] = useState<string>('');
  const [practiceNumber, setPracticeNumber] = useState<string>('');
  const [practiceZip, setPracticeZip] = useState<string>('');
  const [practiceCity, setPracticeCity] = useState<string>('');
  const [practiceCountry, setPracticeCountry] = useState<string>('');
  const [practicePath, setPracticePath] = useState<string>('');
  const [practiceIban, setPracticeIban] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [birthDate, setBirthDate] = useState<string>('');
  const [mobile, setMobile] = useState<string>('');
  const [country, setCountry] = useState<string>('');
  const [skillIds, setSkillIds] = useState<number[]>([]);
  const [emailExists, setEmailExists] = useState<boolean>(false);
  const [gdprAccepted, setGdprAccepted] = useState<boolean>(false);
  const [asRestricted, setAsRestricted] = useState<boolean>(!onlyFull);
  const [showAllChips, setShowAllChips] = useState<boolean>(false);
  const [showGdpr, setShowGdpr] = useState<boolean>(false);
  const [choiceWasMade, setChoiceWasMade] = useState<boolean>(!!onlyFull);

  const [errors, setErrors] = useState<{[z:string]: boolean}>({});

  const [isRegisterError, setIsRegisterError] = useState<boolean>(false);
  const [registerLoading, setRegisterLoading] = useState<boolean>(false);
  const [registerSuccess, setRegisterSuccess] = useState<boolean>(false);
  const [registerError, setRegisterError] = useState<{
    success: boolean;
    data: any;
  }>();
  const [isCheckEmailError, setIsCheckEmailError] = useState<boolean>(false);
  const [checkEmailError, setCheckEmailError] = useState<{
    success: boolean;
    data: any;
  }>();

  // const {
  //   data: coachSkills,
  //   isLoading: coachSkillsLoading,
  //   isError: coachSkillsError,
  //   isSuccess: coachSkillsSuccess,
  //   // refetch: coachesRefetch,
  // } = useQuery({
  //   queryKey: ["coach_skills"],
  //   queryFn: () =>
  //     fetch_all<CoachSkill>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
  //       {
  //         object: 'coach_skill',
  //         fields: ['id', 'name'],
  //         order: 'name ASC'
  //       }
  //     ),
  //   enabled: true
  // });
  const {
    data: coachSkills,
    isLoading: coachSkillsLoading,
    isError: coachSkillsError,
    isSuccess: coachSkillsSuccess,
    refetch: coachSkillsRefetch,
  } = useQuery({
    queryKey: ["coach_skills", i18n.resolvedLanguage],
    queryFn: () =>
      fetch_all<CoachSkill>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'coach_skill',
          fields: ['id', 'name', 'name_en', 'name_fr', 'name_de'],
          order: 'name ASC'
        },
        undefined
      ),
    select: (res) => {
      let tempRes:CoachSkill[] = [];
      res.map(rrr => {
        let rrrClone = {...rrr};
        if (!!rrrClone.name_en && i18n.resolvedLanguage === 'en') rrrClone.name = rrrClone.name_en;
        if (!!rrrClone.name_fr && i18n.resolvedLanguage === 'fr') rrrClone.name = rrrClone.name_fr;
        if (!!rrrClone.name_de && i18n.resolvedLanguage === 'de') rrrClone.name = rrrClone.name_de;

        tempRes.push(rrrClone);
      });
      return tempRes
    },
    enabled: true
  });
  const {
    data: countries,
    isLoading: countriesLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    // refetch: obectsRefetch,
  } = useQuery({
    queryKey: ["countries", "select_list", i18n.resolvedLanguage],
    queryFn: () =>
      fetch_all<Country>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'country',
          fields: ['id', 'name', 'iso', 'name_en', 'name_de', 'name_fr'],
          per_page: 20,
          page: 0,
          order: "name ASC"
        }
      ),
    select: (res) => {
      let tempRes:Country[] = [];
      res.map(rrr => {
        let rrrClone = {...rrr};
        if (!!rrrClone.name_en && i18n.resolvedLanguage === 'en') rrrClone.name = rrrClone.name_en;
        if (!!rrrClone.name_fr && i18n.resolvedLanguage === 'fr') rrrClone.name = rrrClone.name_fr;
        if (!!rrrClone.name_de && i18n.resolvedLanguage === 'de') rrrClone.name = rrrClone.name_de;

        tempRes.push(rrrClone);
      });
      return tempRes
    },
    enabled: true,
  });









  const mutationCheckEmail = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{exists: boolean}>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/check_email`,
        pars.formData,
        undefined
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      setIsCheckEmailError(false);
      setCheckEmailError(undefined);
      return true;
    },
    onError: (data, variables, context) => {
      setIsCheckEmailError(true);
      setCheckEmailError(data as any);
      return true;
    },
    onSuccess: (data, variables, context) => {
      // console.log(data);
      if (!!data.exists) {
        setErrors({email: true});
      } else {
        mutationCustomAction.mutate({formData: {
          object: 'user',
          class_action: 'custom_api_register_coach',
          fields: ['id', 'email'],
          is_restricted: asRestricted ? '1': '0',
          user: {
            first_name: firstName,
            last_name: lastName,
            email: email,
            country_id: country,
            birth_date: birthDate,
            enabled: 1,
            is_agreed: gdprAccepted ? 1 : 0,
            phone_mobile: mobile,
            coach_skill_ids: skillIds
          },
          practice: {
            name: practiceName,
            support_email: practiceEmail,
            ...(!asRestricted ? {
              street: practiceStreet,
              number: practiceNumber,
              zip: practiceZip,
              city: practiceCity,
              country_id: practiceCountry,
              iban: practiceIban,
              url_path: practicePath
            } : {})
          }
        }});
      }
    },
  });

  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{
        custom_result: {
          success: boolean,
          error?: string
        }
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/custom_action`,
        pars.formData,
        undefined
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setRegisterSuccess(data.custom_result.success);
    },
  });








  
  const doRegister = () => {
    mutationCheckEmail.mutate({formData: {
      email: email
    }});
  };

  return (<Grid container item xs={12} spacing={1} direction="row-reverse" sx={{
    position: 'relative'
  }}>
    {registerLoading && <Box sx={{
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 8,
      left: 8,
      zIndex: 999,
      backgroundColor: 'lightgrey',
      opacity: 0.6
    }}>
      
    </Box>}
    {registerLoading && <CircularProgress sx={{
      marginLeft: '-20px',
      marginRight: '-20px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      zIndex: 1000
    }} />}
    
    {registerSuccess && <>
      <Grid sx={{
        alignItems: "center",
        position: "relative",
        lexDirection: "column"
      }} item xs={12}>
        <Typography variant="h6" sx={{
          marginBottom: 2
        }}>{t("shared.signup.success_coach.title")}</Typography>
        <Typography>{t("shared.signup.success_coach.text")}</Typography>
      </Grid>
    </>}
    {!registerSuccess && !choiceWasMade && <>
      <Grid sx={{
        alignItems: "center",
        position: "relative",
        lexDirection: "column",
        paddingLeft: `24px !important`
      }} xs={12}>
        <Box>
          <Typography variant="h1" sx={{
            textAlign: 'center',
            color: theme.palette.primary.main
          }}>
            {t("shared.signup.info.title_choice")}
          </Typography>

          <Grid container spacing={1} sx={{marginTop: 3}}>
            <Grid item xs={12} sm={6} sx={{textAlign: 'center'}}>
              <Typography variant="h3">{t("shared.signup.info.title_choice_free")}</Typography>
              <Typography variant="body1" sx={{textAlign: 'left'}}>{t("shared.signup.info.body_choice_free")}</Typography>
              <Button
                id="free_btn"
                text
                // fullwidth
                onClick={(e) => {
                  setChoiceWasMade(true);
                  setAsRestricted(true);
                }}
                label={t("shared.buttons.choice_free")}
                sx={{margin: 1}}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{textAlign: 'center'}}>
              <Typography variant="h3">{t("shared.signup.info.title_choice_paying")}</Typography>
              <Typography variant="body1" sx={{textAlign: 'left'}}>{t("shared.signup.info.body_choice_paying")}</Typography>
              <Button
                id="paying_btn"
                text
                // fullwidth
                onClick={(e) => {
                  setChoiceWasMade(true);
                  setAsRestricted(false);
                }}
                label={t("shared.buttons.choice_paying")}
                sx={{margin: 1}}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </>}
    {!registerSuccess && !!choiceWasMade && <>
      <Grid sx={{
        alignItems: "center",
        position: "relative",
        lexDirection: "column",
        paddingLeft: `24px !important`
      }} item sm={6} xs={12}>
        <Box>
          <Typography variant="h1" sx={{
            textAlign: 'center',
            color: theme.palette.primary.main
          }}>
            {t("shared.signup.info.title_practice")}
          </Typography>

          <Grid container spacing={1}>

            <Grid item xs={12} sx={{marginTop: 3}}>
              <TextInput
                id="practice_name"
                placeholder={t("shared.signup.field.practice_name")}
                caption={t("shared.signup.field.practice_name")}
                starred
                value={practiceName}
                onChange={(v) => {
                  setPracticeName(v);
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextInput
                id="suport_email"
                placeholder={t("shared.signup.field.practice_suport_email")}
                caption={t("shared.signup.field.practice_suport_email")}
                starred
                value={practiceEmail}
                onChange={(v) => {
                  setPracticeEmail(v);
                }}
              />
            </Grid>
            {!asRestricted && <>
              <Grid item xs={12}>
                <TextInput
                  id="url_path"
                  placeholder={t("shared.signup.field.practice_url_path")}
                  caption={t("shared.signup.field.practice_url_path")}
                  starred
                  value={practicePath}
                  onChange={(v) => {
                    setPracticePath((v || '').replace(/[^a-zA-Z0-9\_\-]/g, ''));
                  }}
                />
              </Grid>
              <Grid item xs={12} sx={{marginTop: 2}}>
                <Typography variant="h5">{t("shared.signup.subtitle.invoicing_details")}</Typography>
              </Grid>
              <Grid item xs={8}>
                <TextInput
                  id="street"
                  placeholder={t("shared.signup.field.practice_street")}
                  caption={t("shared.signup.field.practice_street")}
                  starred
                  value={practiceStreet}
                  onChange={(v) => {
                    setPracticeStreet(v);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextInput
                  id="number"
                  placeholder={t("shared.signup.field.practice_number")}
                  caption={t("shared.signup.field.practice_number")}
                  starred
                  value={practiceNumber}
                  onChange={(v) => {
                    setPracticeNumber(v);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextInput
                  id="zip"
                  placeholder={t("shared.signup.field.practice_zip")}
                  caption={t("shared.signup.field.practice_zip")}
                  starred
                  value={practiceZip}
                  onChange={(v) => {
                    setPracticeZip(v);
                  }}
                />
              </Grid>
              <Grid item xs={8}>
                <TextInput
                  id="city"
                  placeholder={t("shared.signup.field.practice_city")}
                  caption={t("shared.signup.field.practice_city")}
                  starred
                  value={practiceCity}
                  onChange={(v) => {
                    setPracticeCity(v);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Select
                  fullWidth
                  displayEmpty
                  caption={t("shared.signup.field.country")}
                  starred
                  id="practice_country"
                  value={practiceCountry}
                  setValue={(v) => {
                    setPracticeCountry(v.toString());
                  }}
                >
                  <MenuItem value="">{t("shared.signup.field.country")}</MenuItem>
                  {(countries || []).map((country) => (<MenuItem value={country.iso}>{country.name}</MenuItem>))}
                </Select>
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  id="iban"
                  placeholder={t("shared.signup.field.practice_iban")}
                  helperText={t("shared.signup.field.practice_iban_helper")}
                  caption={t("shared.signup.field.practice_iban")}
                  starred
                  value={practiceIban}
                  onChange={(v) => {
                    setPracticeIban(v);
                  }}
                />
              </Grid>
            </>}

            <Grid item xs={12} sx={{
              display: "flex",
              alignItems: "center",
              "& > label": {
                padding: 1
              },
              "&.error": {
                border: "0.5px solid rgba(255, 0, 0, 0.5)"
              }
            }}>
              <Checkbox
                checked={gdprAccepted}
                onChange={(e) => {
                  setGdprAccepted(e.target.checked);
                }}
                value="gdpr"
              />
              <Typography html>{t(asRestricted ? "restricted.profile.gdpr_nutrilink_checkbox_text" : "client.register.gdpr_nutrilink_for_coach")}</Typography>
            </Grid>
            <Grid item xs={12} style={{display: "flex"}}>
              <Button
                contained
                id="toggle_gdpr"
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  setShowGdpr(!showGdpr);
                }}
                sx={{
                  marginTop: 1
                }}
                label={t(!!showGdpr ? "client.register.gdpr_practice_toggle_off" : "client.register.gdpr_practice_toggle_on")}
              />
            </Grid>
            {!!showGdpr && <Grid item xs={12} sx={{display: "flex"}}>
              <Typography html>{t("restricted.profile.gdpr_nutrilink")}</Typography>
            </Grid>}
          </Grid>
        </Box>
      </Grid>
      <Grid sx={{
        alignItems: "center",
        position: "relative",
        lexDirection: "column",
        paddingRight: `24px !important`
      }} item sm={6} xs={12}>
        <Box>
          <Typography variant="h1" sx={{
            textAlign: 'center',
            color: theme.palette.primary.main
          }}>
            {t("shared.signup.info.title_personal")}
          </Typography>

          <Grid container spacing={1}>

            {/* <Grid item xs={12} sx={{
              display: "flex",
              alignItems: "center",
              "& > label": {
                padding: 1
              },
              "&.error": {
                border: "0.5px solid rgba(255, 0, 0, 0.5)"
              },
              marginTop: 3
            }}>
              <Checkbox
                checked={asRestricted}
                onChange={(e) => {
                  setAsRestricted(e.target.checked);
                }}
                value="as_restricted"
              />
              <Typography html>{t("shared.register.coach_as_restricted")}</Typography>
            </Grid> */}

            <Grid item xs={12} sm={6} sx={{marginTop: 3}}>
              <TextInput
                id="first_name"
                placeholder={t("shared.signup.field.first_name")}
                caption={t("shared.signup.field.first_name")}
                starred
                value={firstName}
                onChange={(v) => {
                  setFirstName(v);
                }}
                sx={{
                  marginTop: 0
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{marginTop: {xs: 0, sm: 3}}}>
              <TextInput
                id="last_name"
                placeholder={t("shared.signup.field.last_name")}
                caption={t("shared.signup.field.last_name")}
                starred
                value={lastName}
                onChange={(v) => {
                  setLastName(v);
                }}
                sx={{
                  marginTop: 0
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextInput
                error={emailExists ? t("shared.signup.error.email_exist") : undefined}
                id="email"
                placeholder={t("shared.signup.field.email")}
                caption={t("shared.signup.field.email")}
                starred
                type="email"
                value={email}
                onChange={(v) => {
                  setEmail(v);
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="caption">{t("shared.signup.field.birth_date")}&nbsp;*</Typography>
              <DatePicker
                label={t("shared.signup.field.birth_date")}
                disableFuture
                noIcon
                openTo="year"
                format="DD"
                views={["year", "month", "day"]}
                id="birth_day"
                value={birthDate}
                setValue={(v) => {
                  setBirthDate(v);
                }}
                sx={{field: {marginTop: 0}}}
              />
            </Grid>

            <Grid item xs={12}>
              <Select
                fullWidth
                displayEmpty
                caption={t("shared.signup.field.country")}
                starred
                id="country"
                value={country}
                setValue={(v) => {
                  setCountry(v.toString());
                }}
              >
                <MenuItem value="">{t("shared.signup.field.country")}</MenuItem>
                {(countries || []).map((country) => (<MenuItem value={country.iso}>{country.name}</MenuItem>))}
              </Select>
            </Grid>

            <Grid item xs={12}>
              <TextInput
                id="phone_mobile"
                placeholder={t("shared.signup.field.phone_mobile")}
                caption={t("shared.signup.field.phone_mobile")}
                starred
                type="tel"
                value={mobile}
                onChange={(v) => {
                  setMobile(v);
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="caption" sx={{display:'block'}}>{t("coach.submenu.account_settings.skills")}:</Typography>
              {!showAllChips && (coachSkills || []).sort((a, b) => (skillIds.filter(fff => fff === b.id).length - skillIds.filter(fff => fff === a.id).length) || a.name.localeCompare(b.name)).slice(0, skillIds.length > 6 ? skillIds.length : 6).map(skill => <Chip
                sx={{marginRight: 1, marginBottom: 1, cursor: 'pointer'}}
                label={skill.name}
                onClick={(e) => {
                  if (skillIds.filter(fff => fff === skill.id).length > 0) {
                    setSkillIds(skillIds.filter(fff => fff !== skill.id));
                  } else {
                    setSkillIds([...skillIds, skill.id]);
                  }
                }}
                variant="outlined"
                icon={skillIds.filter(fff => fff === skill.id).length > 0 ? <DoneIcon /> : <AddIcon />}
                color={skillIds.filter(fff => fff === skill.id).length > 0 ? "primary" : 'default'}
              />)}
              {!showAllChips && <Chip
                sx={{marginRight: 1, marginBottom: 1, cursor: 'pointer'}}
                label={t("shared.chips.show_more")}
                onClick={(e) => {
                  setShowAllChips(true);
                }}
                variant="outlined"
                icon={<VisibilityIcon />}
                color="primary"
              />}
              {!!showAllChips && (coachSkills || []).sort((a, b) => (skillIds.filter(fff => fff === b.id).length - skillIds.filter(fff => fff === a.id).length) || a.name.localeCompare(b.name)).map(skill => <Chip
                sx={{marginRight: 1, marginBottom: 1, cursor: 'pointer'}}
                label={skill.name}
                onClick={(e) => {
                  if (skillIds.filter(fff => fff === skill.id).length > 0) {
                    setSkillIds(skillIds.filter(fff => fff !== skill.id));
                  } else {
                    setSkillIds([...skillIds, skill.id]);
                  }
                }}
                variant="outlined"
                icon={skillIds.filter(fff => fff === skill.id).length > 0 ? <DoneIcon /> : <AddIcon />}
                color={skillIds.filter(fff => fff === skill.id).length > 0 ? "primary" : 'default'}
              />)}
              {!!showAllChips && <Chip
                sx={{marginRight: 1, marginBottom: 1, cursor: 'pointer'}}
                label={t("shared.chips.show_less")}
                onClick={(e) => {
                  setShowAllChips(false);
                }}
                variant="outlined"
                icon={<VisibilityOff />}
                color="primary"
              />}
            </Grid>

            <Alert
              hidden={!isRegisterError}
              title={t("shared.signup.error.title")}
              content={t("shared.signup.error.text")}
            />

          </Grid>

          {/* {this.props.renderForm(this.props.practice || this.props.subdomain_practice)} */}
        </Box>
        {!!matchessm && (<Box sx={{
          position: "absolute",
          backgroundColor: theme.palette.primary.main,
          [theme.breakpoints.up('sm')]: {
            height: "100%",
            top: 0,
            right: 0,
            width: '1px'
          },
          [theme.breakpoints.down('sm')]: {
            width: "100%",
            bottom: 0,
            left: 0,
            height: '1px'
          }
        }}></Box>)}
      </Grid>
    </>}

    <Grid item xs={12} sx={{textAlign: 'center'}}>
      {!registerSuccess && !!choiceWasMade && <Button
        // type="submit"
        id="submit_register"
        contained
        disabled={
          !firstName || !lastName || !email || !birthDate || !country || !mobile || !practiceName || !practiceEmail || 
          !gdprAccepted || (
            !asRestricted && (
              !practiceStreet || !practiceNumber || !practiceZip || !practiceCity || !practiceCountry || !practiceIban
            )
          )
        }
        onClick={(e) => {
          doRegister();
        }}
        label={t("shared.buttons.register")}
        // fullwidth
        sx={{margin: 1}}
      />}
      <Button
        id="back_btn"
        text
        // fullwidth
        onClick={(e) => {
          if (!choiceWasMade) {
            navigate("/login");
            // @ts-ignore
            if(!!document.getElementById("subscroller")) document.getElementById("subscroller").scrollTo(0, 0);
          } else {
            setChoiceWasMade(false);
            setAsRestricted(false);
          }
        }}
        label={t("shared.buttons.have_account_onboarding")}
        sx={{margin: 1}}
      />
    </Grid>
  </Grid>);
}
